// extracted by mini-css-extract-plugin
export default {"wrapper":"Config_wrapper__Ndm9W","headerActions":"Config_headerActions__wMg7W","footerActions":"Config_footerActions__Um5jH"};